
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMasterLicense } from '@/hooks/useMasterLicense';
import MasterLicenseLayout from '@/components/masterlicense/MasterLicenseLayout';
import PendingOrdersTable from '@/components/masterlicense/orders/PendingOrdersTable';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Search, Calendar, Clock } from 'lucide-react';

const MasterLicensePendingOrders = () => {
  const navigate = useNavigate();
  const {
    isLoading,
    handleLogout,
    activeTab,
    setActiveTab,
    pendingOrdersCount
  } = useMasterLicense();

  React.useEffect(() => {
    setActiveTab("pending-orders");
  }, [setActiveTab]);

  return (
    <MasterLicenseLayout
      isLoading={isLoading}
      onLogout={handleLogout}
      activeTab="pending-orders"
      userRole="Master Admin"
    >
      <div className="container mx-auto px-4 py-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold">Reseller Orders Management</h1>
          <p className="text-gray-600">
            Review, approve, and process reseller orders
          </p>
        </div>
        
        <div className="mb-6">
          <Tabs defaultValue="pending">
            <div className="flex justify-between items-center mb-4">
              <TabsList>
                <TabsTrigger value="pending" className="flex items-center gap-2">
                  <Clock className="h-4 w-4" />
                  Pending Orders
                  {pendingOrdersCount > 0 && (
                    <span className="inline-flex items-center justify-center w-5 h-5 ml-1 text-xs font-semibold text-white bg-primary rounded-full">
                      {pendingOrdersCount}
                    </span>
                  )}
                </TabsTrigger>
                <TabsTrigger value="all" className="flex items-center gap-2">
                  <Calendar className="h-4 w-4" />
                  All Orders
                </TabsTrigger>
              </TabsList>
              
              <div className="flex">
                <div className="relative">
                  <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-400" />
                  <Input 
                    placeholder="Search orders..." 
                    className="pl-8 w-64" 
                  />
                </div>
                <Button className="ml-2" variant="outline">
                  Filter
                </Button>
              </div>
            </div>
            
            <TabsContent value="pending">
              <PendingOrdersTable />
            </TabsContent>
            
            <TabsContent value="all">
              <Card>
                <CardHeader>
                  <CardTitle>All Orders</CardTitle>
                  <CardDescription>View and manage all reseller orders</CardDescription>
                </CardHeader>
                <CardContent>
                  <p className="text-center py-8 text-gray-500">
                    This tab will contain the complete order history, including activated, rejected, and pending orders.
                  </p>
                </CardContent>
              </Card>
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </MasterLicenseLayout>
  );
};

export default MasterLicensePendingOrders;
